// ---
/**
 * Pomocné metody a výčtové hodnoty pro subjekty v případu.
 */

import {utils, modal} from './../index';
import * as TypSubjektu from "./../api/gen/proxioapi/TypSubjektu";
import * as StavZtotozneniZr from "./../api/gen/proxioapi/StavZtotozneniZr";
import {localUTCToDate, dateToDateString} from "./../utils/commons";

/**
 * Načtení titulku dialogu pro editační formulář.
 * @param subjektAddFormTitle prefix dialogu, např. "Zástupce" nebo null
 * @param typSubjektu typ subjektu
 * @param sharedSubjekt true, pokud se upravuje centrální subjekt v shared
 * @return {*} editační text, např. "Zástupce - Upravit fyzickou osobu"
 */
export function getEditDialogTitle(subjektAddFormTitle, typSubjektu, sharedSubjekt) {
    let caption;
    switch (typSubjektu) {
        case TypSubjektu.FO:
            caption = "Upravit fyzickou osobu";
            break;
        case TypSubjektu.PO:
            caption = "Upravit právnickou osobu";
            break;
        case TypSubjektu.FOP:
            caption = "Upravit podnikající fyzickou osobu";
            break;
        case TypSubjektu.NO:
            caption = "Upravit neznámou osobu";
            break;
    }
    if (subjektAddFormTitle) {
        caption = subjektAddFormTitle + " - " + caption;
    }

    if (sharedSubjekt) {
        caption += " (číselník subjektů)";
    }

    return caption;
}

/**
 * Otestuje, zda je nějak vyplněna odpovědná osoba - pro uložení.
 * @param odpovednaOsoba true, pokud je na ní alespoň něco vyplněno
 */
export function checkOdpovednaOsobaFilled(odpovednaOsoba) {
    if (odpovednaOsoba.jmeno || odpovednaOsoba.prijmeni || (odpovednaOsoba.email && odpovednaOsoba.email.kontakt) || (odpovednaOsoba.telefon && odpovednaOsoba.telefon.kontakt)) {  // něco je vyplněno na uložení
        return true;
    } else {    // odpovědnou osobu nechceme
        return false;
    }
}

export function getSubjektClass(typSubjektu) {
    switch (typSubjektu) {
        case TypSubjektu.FO:
            return "FyzickaOsobaVO";
        case TypSubjektu.PO:
            return "PravnickaOsobaVO";
        case TypSubjektu.FOP:
            return "FyzickaOsobaPodVO";
            break;
        case TypSubjektu.NO:
            return "NeznamaOsobaVO";
    }
    return null;
}

export function doplnTriduSubjektu(typSubjektu, subjekt) {
    let subjektData;
    switch (typSubjektu.toLowerCase()) {
        case "fo":
            subjektData = {
                ...subjekt,
                '@class': 'FyzickaOsobaVO'
            };
            break;
        case "fop":
            subjektData = {
                ...subjekt,
                '@class': 'FyzickaOsobaPodVO'
            };
            break;
        case "po":
            subjektData = {
                ...subjekt,
                '@class': 'PravnickaOsobaVO'
            };
            break;
        case "no":
            subjektData = {
                ...subjekt,
                '@class': 'NeznamaOsobaVO'
            };
            break;
        default:
            modal.ModalActions.showInfo("Nepodporovaný typ osoby", "Nepodporovaný typ osoby");
            return;
    }
    return subjektData;
}

/**
 * Vrátí datum narození z rodného čísla.
 * @param rc
 * @returns {*}
 */
export function getDatumNarozeniFromRC(rc) {
    if (!rc) {
        return null;
    }
    var rok = Number(rc.substring(0, 2));
    if (rc.length === 10 && rok < 54) {
        rok += 2000;
    } else if (rc.length === 9 && rok >= 54) {
        rok += 1800;
    } else {
        rok += 1900;
    }

    var mesicAPohlavi = Number(rc.substring(2, 4));

    var mesic = mesicAPohlavi % 50;
    if (mesic > 12) {
        mesic -= 20;
    }

    var den = Number(rc.substring(4, 6));
    return new Date(rok, mesic - 1, den);
}

/**
 * Zjistí, zda lze subjekt aktualizovat ze ZR - tedy zda má vazbu na zr a je ve stavu, kdy je možné volat aktualizaci (např. není ve stavu pozastaven, neztotožněn  apod.)
 * @param subjekt subjekt
 * @return true, pokud lze aktualizovat - lze volat aktualizaci na serveru
 */
export function lzeAktualizovatZeZr(subjekt : Subjekt) {
    if (subjekt.vazbaZr && subjekt.stavZr) {
        switch (subjekt.stavZr.stavZtotozneni) {
            case StavZtotozneniZr.ZTOTOZNEN:
            case StavZtotozneniZr.CHYBA:
                return true;
        }
    }
    return false;
}

/**
 * Načtení informací o úmrtí nebo zániku subjektu
 * @param subjekt subjekt
 * @return {{dead: boolean, title: *}}
 */
export function getDeadInfo(subjekt : Subjekt) {
    let title;
    let dead = false;
    if (subjekt.typSubjektu === TypSubjektu.FO && subjekt.datumUmrti != null) {
        dead = true;
        let misto = subjekt.mistoUmrti ? ` v místě ${subjekt.mistoUmrti}` : "";
        title = `Datum úmrtí dne ${dateToDateString(localUTCToDate(subjekt.datumUmrti))}${misto}`;
    } else if ((subjekt.typSubjektu === TypSubjektu.PO || subjekt.typSubjektu === TypSubjektu.FOP) && subjekt.datumZanik != null) {
        dead = true;
        title = `Datum zániku dne ${dateToDateString(localUTCToDate(subjekt.datumZanik))}`;
    }

    return {
        dead,
        title
    }
}
